
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import capitalRangeService from '@/apps/shared/services/capitalRange-service';
    import typesOptionsGroupService from '@/apps/shared/services/typesOptionsGroup-service';
    import theftQuotationService from '@/apps/shared/services/theftQuotation-service';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },
        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante
                if (data.fromTab === 'tab-three') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.getTypesOptionsGroup();
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'tab-three') {
                    sessionStorage.removeItem('ProductValueSelected');
                    sessionStorage.setItem('ProductValueSelected', JSON.stringify(value));
                }
            },
        },
        data() {
            return {
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    tabName: "tab-three",
                    title: "Valor",
                    subTitle: "Seleccioná el rango de valor de tu vehiculo.",
                } as TitleAndPromotionsDetails,
                rangeSelected: null,
                dataAmparo: [],
                relationId: null,
                quotationId: null,
                productId: 936,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                    { text: 'Valor del Vehiculo', path: 'movilidad/valorVehiculo' },
                ],
                onDate: new Date().toISOString(),
                referente: null,
                medium: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            getTypesOptionsGroup: function () {
                var vehicleData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                var valueRange = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                return new Promise<any>(async (resolve) => {
                    sessionStorage.removeItem("ResponseAmparos");
                    sessionStorage.removeItem("DataQuotation");
                    var quotationDataResult = [];
                    var rangeId = valueRange.code != null ? parseInt(valueRange.code) : 1;
                    this.quotationId = null;
                    this.relationId = null;
                    await typesOptionsGroupService.getTypesOptionsGroup(this.productId, '', rangeId, this.onDate, '', '', '', '').then(async responseAmparos => {
                        if (!responseAmparos) {
                            window.globalThis.dataLayer.push({
                                'pas': null,
                                'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                                'product': 'movilidad',
                                'event': 'errorServidor',
                                'paso': 'cotizador-movilidad-valor',
                                'referente': this.referente,
                                'medio': this.medium
                            });
                        } else {
                            sessionStorage.setItem("ResponseAmparos", JSON.stringify(responseAmparos));
                            this.dataAmparo = responseAmparos;
                            for (let o of this.dataAmparo) {
                                var coverCustomitationsArray = [];
                                var amparoTheftOptionsArray = [];
                                o.amparoTheftOptions.forEach(amparoOptions => {
                                    var coverCustomizations = {
                                        coverNumber: amparoOptions.coverCode,
                                        capital: 0,
                                        deductibleType: 0,
                                        rate: 0
                                    };
                                    coverCustomitationsArray.push(coverCustomizations);
                                    var amparoTheftOptions = {
                                        coverCode: amparoOptions.coverCode,
                                        amparoTypes: amparoOptions.amparoTypes,
                                        amparoOption: amparoOptions.amparoOption,
                                        capital: amparoOptions.capital,
                                        amparoTypesDescription: amparoOptions.amparoTypesDescription
                                    }
                                    amparoTheftOptionsArray.push(amparoTheftOptions);
                                });

                                var vehicle = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                                var tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                                var body = JSON.stringify({
                                    userName: '',
                                    userToken: '',
                                    tokenType: '',
                                    correlationInformation: '',
                                    originRequest: "2",
                                    coverCustomizations: coverCustomitationsArray,
                                    clientIdentify: {
                                        documentType: "D",
                                        documentNumber: 0
                                    },
                                    relationId: (this.relationId != null ? this.relationId : 0),
                                    quotationId: this.quotationId != null ? this.quotationId : null,
                                    amparoTheftOptions: amparoTheftOptionsArray,
                                    mobilityTypeId: parseInt(vehicleData.code),
                                    cityId: parseInt(tabOneWelcome.selectedLocality.id),
                                    zipCode: tabOneWelcome.selectedLocality.zipCode
                                });
                                await theftQuotationService.createTheft936Quotation(body).then(async responseTheft936Quotation => {
                                    if (!responseTheft936Quotation) {
                                        NF.Notification.show({
                                            type: NF.Notification.Type.ERROR,
                                            title: 'Error',
                                            content: 'Se produjo un error al cotizar.',
                                            position: NF.Notification.Positions.TOP_RIGHT,
                                            clickClose: true,
                                            autoHideDelay: 10000,
                                        });
                                        this.$refs.productCards.isNavigationAllowed = true;
                                        this.$refs.productCards.isNextTriggered = false;
                                        window.globalThis.dataLayer.push({
                                            'pas': null,
                                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                                            'product': 'movilidad',
                                            'event': 'errorServidor',
                                            'paso': 'cotizador-movilidad-valor'
                                        });
                                        NF.UI.Page.unblock();
                                    } else {
                                        const { plans, quotationId, relationId } = responseTheft936Quotation;
                                        this.quotationId = quotationId;
                                        this.relationId = relationId;
                                        const dataPlans = { plans, quotationId, relationId };
                                        quotationDataResult.push(dataPlans);
                                        sessionStorage.setItem("DataQuotation", JSON.stringify(quotationDataResult));
                                        if (this.dataAmparo.length == quotationDataResult.length) {
                                            resolve(true)
                                            this.$router.push({ name: 'plans-view' });
                                            NF.UI.Page.unblock();
                                        }
                                    }
                                }).catch(error => {
                                    NF.UI.Page.unblock();
                                    let statusCode = null;
                                    // Si es un error de Axios (por ejemplo, 4xx, 5xx)
                                    if (error.response && error.response.status) {
                                        statusCode = error.response.status;
                                    } else if (error.message === '204') {
                                        // Error lanzado manualmente en el service para 204
                                        statusCode = 204;
                                    }
                                    window.globalThis.dataLayer.push({
                                        'pas': null,
                                        'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                                        'product': 'movilidad',
                                        'event': 'errorServidor',
                                        'paso': 'cotizador-movilidad-valor',
                                        'referente': this.referente,
                                        'medio': this.medium
                                    });
                                    this.Bus.$emit('show-service-fail', statusCode, [() => this.getTypesOptionsGroup()]);
                                });
                            }
                        }
                    })
                });
            },

            getCapitalRanges() {
                capitalRangeService.getCapitalRange(this.onDate, this.productId, "", "", "", "", "").then(response => {
                    if (!response) {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'movilidad',
                            'event': 'errorServidor',
                            'paso': 'cotizador-movilidad-cotizacion',
                            'referente': this.referente,
                            'medio': this.medium
                        });
                    }
                    else {
                        var productData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                        var values = response.map(element => ({
                            ...element,
                            code: element["capitalRangeCode"],
                            productDescription: element["description"],
                            getProductDescription: productData && productData.productDescription
                        }));
                        this.$refs.productCards.setProductData(values);
                        NF.UI.Page.unblock();
                    }
                })
            },

            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'cotizador-movilidad',
                })
            },

            getInitData() {
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    'product': 'movilidad',
                    'event': 'cotizador-movilidad-cotizacion',
                    'referente': this.referente,
                    'medio': this.medium
                });
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.getCapitalRanges();
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                    var productData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                    if (productData) {
                        //Llama a la funcion de productCardsSelector.vue, luego de que regresan la pantalla y muestra la opcion elegida
                        this.$refs.productCards.getDataProductBack(productData);
                    }
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                this.getInitData();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
